<kendo-tabstrip (tabSelect)="onTabSelect($event)">
  <kendo-tabstrip-tab *ngFor="let item of stepList; let i = index" (disabled)="item.locked"
    (selected)="item.active">
    <ng-template kendoTabTitle>
      <h5 class="no-margin">{{item.title}}</h5>
    </ng-template>
    <ng-template kendoTabContent>
      <ng-template agsStepperHost></ng-template>
    </ng-template>
  </kendo-tabstrip-tab>
</kendo-tabstrip>

<kendo-window *ngIf="msgOpen" (dragStart)="$event.preventDefault()" (resizeStart)="$event.preventDefault()">
  <kendo-window-titlebar class="small-padding">
    <div class="k-window-title">Impossible d'atteindre l'étape ciblée</div>
  </kendo-window-titlebar>
  <div class="align-center msg-content">
    <p class="small-margin">{{msgText}}</p>
    <button kendoButton type="button" [primary]="true" (click)="msgOpen = !msgOpen">Ok</button>
  </div>
</kendo-window>
